import React, { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  FiMenu,
  FiSearch,
  FiHome,
  FiPhone,
  FiMail,
  FiTwitter,
  FiFacebook,
  FiLinkedin,
  FiPlay
} from "react-icons/fi";
import {
  FaGoogle,
  FaSpotify,
} from "react-icons/fa";
import { connect } from "react-redux";
import {
  fetchPlaylist,
} from "../../store/playList/actions";
import PlaylistCard from "../../components/Playlist/PlaylistCard";

import "./Search.scss";

const Search = (props) => {
  const [state, setState] = React.useState({
    search: "",
    searchResults: [],
  });
  React.useEffect(() => {
    props.fetchPlaylist();
  }, []);
  const handleSearch = () => {
    if (state.search) {
      let searchResults = props.playlist.filter(
        (pl) =>
          pl.title.toLowerCase().includes(state.search.toLowerCase()) ||
          pl?.created_by?.name?.toLowerCase()?.includes(state.search.toLowerCase()) ||
          pl?.created_by?.first_name?.toLowerCase()?.includes(state.search.toLowerCase()) ||
          pl?.created_by?.last_name?.toLowerCase()?.includes(state.search.toLowerCase())
      );
      setState({ ...state, searchResults });
    } else {
      setState({ ...state, searchResults: [] });
    }
  };
  useEffect(() => {
    if (!state.search) {
      setState({ ...state, searchResults: props.playlist });
    }else{
      handleSearch()
    }
  }, [state.search]);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const cards = [
    { img: "/images/bg/1.webp" },
    { img: "/images/bg/2.jpg" },
    { img: "/images/bg/3.jfif" },
    { img: "/images/bg/4.jfif" },
    // { img: "/images/bg/5.png" },
  ];
  useEffect(() => {
    const key = props?.match?.params?.key;
    if(key){
      setState({...state, search: key})
    }
  }, [])
  return (
    <div className="search">
      <div
        className={`nav fixed-top bg-white shadow-sm bg`}
      >
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-start align-items-center flex-1">
            <Link to="/" className="">
              <img className="logo shadow-sm" src="/images/logo/music.png" />
            </Link>
            <div style={{ width: 20 }} />
            <div id="search" className="search shadow-sm">
              <button className="search-btn">
                <FiSearch />
              </button>
              <input
                type="text"
                name=""
                id=""
                placeholder="Start your search: guitar..."
                value={state.search}
                onChange={(e)=>setState({...state, search:e.target.value})}
              />
            </div>
              <button className="btn btn-primary" style={{marginLeft: 10, marginRight: 20}}>Search</button>
          </div>
          <div className="d-flex justify-content-center align-items-center ">
            <div className="drop ml-4">
              <div
                className="menu"
                onClick={() => {
                  setMenuOpen(!menuOpen);
                }}
              >
                <FiMenu />
                {/* <img src="/images/bg/pp.png" alt="" /> */}
              </div>
              <div
                className={`dropdown shadow ${
                  menuOpen === false ? "active" : ""
                }`}
              >
                <Link to="/login" className="link">
                  Sign In
                </Link>
                <Link to="/signUp" className="link">
                  Sign Up
                </Link>
                <div className="devider d-block d-lg-none"></div>
                <Link to="/login" className="link  d-block d-lg-none">
                  Become a Professional
                </Link>
                <div className="devider"></div>
                <Link to="/" className="link">
                  FAQs
                </Link>
                <Link to="/" className="link">
                  privacy policy
                </Link>
                <Link to="/" className="link">
                  terms of use
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section
        className=""
        // style={{
        //   backgroundImage:
        //     "linear-gradient(180deg,#551a8bee, #9966cc88), url(/images/bg/3.jfif)",
        // }}
      >
        <div className="container mt-5 pt-5">
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
            {state.searchResults.map((item, i) => (
              <PlaylistCard item={item} key={i} />
            ))}
          </div>
        </div>
      </section>
      <div className="footer bg-dark text-white py-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-3">
              <Link to="/" className="">
                <img className="logo shadow-sm" src="/images/logo/music.png" />
              </Link>
            </div>
            <div className="col-12 col-lg-3 flex-column-center-mobile">
              <div className="header">Contact Information</div>
              <div className="ul">
                <div className="d-flex li">
                  <FiHome />
                  <div className="text">
                    Plant B. Manager 71 Old Church St Kensington, SW3 5BS
                  </div>
                </div>
                <div className="d-flex li">
                  <FiPhone />
                  <div className="text">0845 054 7101</div>
                </div>
                <div className="d-flex li">
                  <FiMail />
                  <div className="text">contact@example.com</div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-3 flex-column-center-mobile">
              <div className="header">Helpful Links</div>
              <div className="ul">
                <div className="d-flex li">
                  <Link to="/" className="text">
                    About Us
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    Services
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    Point System
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    Testimonials
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/signup" className="text">
                    Sign Up
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-3 flex-column-center-mobile">
              <div className="header">Keep Connected</div>
              <div className="ul d-flex">
                <div className="d-flex li">
                  <Link to="/" className="text">
                    <FiFacebook />
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    <FiTwitter />
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    <FaGoogle />
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    <FiLinkedin />
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    <FaSpotify />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  playlist: state.playlist.playlist,
});

export default connect(mapStateToProps, {
  fetchPlaylist,
})(Search);
